import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { AuthService } from "../auth.service";
import { LoginModel } from "../auth-models";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginFailed = false;
  enterTwoFactorCode = false;
  errorMessage: string = null;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService
  ) {}

  /*
  // Moved to ngOnInit to avoid initialization errors.
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  */
  isHandset$: Observable<boolean>;

  ngOnInit() {
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
      map((result) => result.matches),
      shareReplay()
    );
  }

  onSubmit(creds: LoginModel) {
    this.loginFailed = false;
    this.authService.login(creds).subscribe(
      (u) => {
        if (!creds.code && u.twoFactorEnabled) {
          this.enterTwoFactorCode = true;
          return;
        }

        if (this.authService.isAuthenticated) {
          this.authService.navigatePostAuth();
        }
      },
      (err: any) => {
        console.error("Login failed", err);
        this.loginFailed = true;
        this.errorMessage = "There was an error logging in";
      }
    );
  }

  // Reuses the sign-in error slot so the message is shown and announced like any
  // other login failure. The credentials are fine, so the wording points at the
  // retry rather than blaming what the user typed.
  onRecaptchaFailed() {
    this.loginFailed = true;
    this.errorMessage =
      "Could not verify your browser. Please check your connection and try again.";
  }
}
